import React from 'react';
import { UserProfile } from '../../logic/components';

const UserProfileRoute = () => {
  return <UserProfile />;
};

export default React.memo(UserProfileRoute);
